<app-input [form]="form"
           [ngClass]="{
            changed: formChanges[controlName]
           }"
           [controlName]="controlName"
           [hint]="formChanges[controlName] && 'dashboard_report.name_change_message'"
           [label]="label"
           appearance="outline"
           (onKeyUp)="onKeyUp()"></app-input>
